import React, { useState } from "react";
import { FiXCircle } from "@react-icons/all-files/fi/FiXCircle";
import { FiArrowLeft } from "@react-icons/all-files/fi/FiArrowLeft";
import { FiArrowRight } from "@react-icons/all-files/fi/FiArrowRight";

import { IRetailMatchJobImage } from "../../../../../Models/Models";
import { IntroGridBlockTwo } from "../../Styled/RetailGrid";
import {
    LightboxImageContainer,
    LightboxBackdrop,
    LightboxImage,
    Lightbox,
} from "../../Styled/PhotoCarouselLightbox";
import { RetailMatchCarouselImage } from "../../Styled/RetailMatchIntroStyles";

export interface RetailMatchIntroPhotoCarouselProps {
  images: IRetailMatchJobImage[];
  showCarouselModal: boolean;
  setShowCarouselModal: (show: boolean) => void;
}

export const RetailMatchIntroPhotoCarousel = (
    props: RetailMatchIntroPhotoCarouselProps
) => {
    const { images, showCarouselModal, setShowCarouselModal } = props;

    const [selectedImageIndex, setSelectedImageIndex] = useState<number>(0);

    const handleImageClick = (index: number) => {
        setSelectedImageIndex(index);
        setShowCarouselModal(true);
    };

    const handleRightArrowClick = (): void => {
        let nextIndex = selectedImageIndex + 1;

        if (nextIndex > images.length - 1) {
            nextIndex = 0;
        }

        setSelectedImageIndex(nextIndex);
    };

    const handleLeftArrowClick = (): void => {
        let nextIndex = selectedImageIndex - 1;

        if (nextIndex < 0) {
            nextIndex = images.length - 1;
        }
        setSelectedImageIndex(nextIndex);
    };

    return (
        <>
            <IntroGridBlockTwo>
                {images.slice(0, 4).map((image: IRetailMatchJobImage, i: number) => (
                    <RetailMatchCarouselImage
                        key={i}
                        backgroundImage={image.url}
                        onClick={() => handleImageClick(i)}
                    />
                ))}
            </IntroGridBlockTwo>
            {showCarouselModal ? (
                <LightboxBackdrop>
                    <FiXCircle
                        color="whitesmoke"
                        style={{
                            right: "5px",
                            margin: "8px",
                            cursor: "pointer",
                            position: "absolute",
                            top: "3.8rem"
                        }}
                        onClick={() => setShowCarouselModal(false)}
                    />
                    <Lightbox>
                        <LightboxImageContainer>
                            <FiArrowLeft color="whitesmoke" onClick={handleLeftArrowClick} />
                            <LightboxImage
                                style={{
                                    backgroundImage: `url(${images[selectedImageIndex]?.url})`,
                                }}
                            />
                            <FiArrowRight
                                color="whitesmoke"
                                onClick={handleRightArrowClick}
                            />
                        </LightboxImageContainer>
                        <IntroGridBlockTwo>
                            {images.map((image: IRetailMatchJobImage, i: number) => (
                                <RetailMatchCarouselImage
                                    key={i}
                                    selectedImage={
                                        showCarouselModal ? i === selectedImageIndex : true
                                    }
                                    backgroundImage={image.url}
                                    onClick={() => handleImageClick(i)}
                                />
                            ))}
                        </IntroGridBlockTwo>
                    </Lightbox>
                </LightboxBackdrop>
            ) : null}
        </>
    );
};
